import { createContext, useContext } from 'react';
import { AssistantContextValue } from './interviewContextModel';
import { AssistantContextProvider } from './interviewContextInterface';

export function createAssistantContext(): AssistantContextProvider {
    const Context = createContext<AssistantContextValue | null>(null);
    return {
        useContext() {
            const context = useContext(Context);
            if (!context) {
                throw new Error('expected context');
            }
            return context;
        },
        Provider: Context.Provider,
    };
}
